<!-- 网点管理首页页面 -->
<script>
import {Dialog} from "vant";
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
// 动态表单模版
import Temp from '@/components/technician/temp/index';
//网点营业状态
import SiteInfoModal from "@/components/lottery/updateSiteInfo/index.vue";
import {delLocalItem, getLocalItem, setLocalItem} from '@/untils/common';
import {
  agentInfoList,
  updateBranchInfo,
  logoutRequest,
  salespersonInfoList,
  branchInfoList,
  // salesUserInfo,
  processFlowinit,
  processIsinservice,
  // processGeneralsubmit,
  processFlowlist,
  processAllmytask,
  xzsStaffInfoParty,
  processTaskHistorical, processRemove,
  // processRemove
} from "@/lib/request";
export default {
  name:'userHome',
  data(){
    return{
      content:'',
      chockFlag:false,
      innerLoading:true,
      // 动态表单模版
      siteIdObj:{},
      returnObj:{},
      formDefine:{},
      flowNameObj:{},
      formFields:[],
      flagTemp:false,
      historyList:[],
      //角色类型
      roleName:'',
      // 角色列表
      roleList:[],
      showRoleFlag:false,
      // 网点列表
      showFlag:false,
      // 网点列表
      listSite:[
        // {
        //   branchId:'54010001',
        //   businessType:'1',
        //   branchType:'1',//1福彩单机  2福体双机
        //   .....
        // }
      ],
      // 停业申请
      stopBusinessFlag:false,
      // 当前网点信息
      siteItem:{
        // 'branchId':'54010001',
        // 'businessStatus':1,
        // 'businessType':'1'
      },
      // 网点申请列表
      dataApplyList:[],
      // 流程类型列表
      listPramsObj:[
        // {
        //   "msgs": [
        //     {
        //       "category": "西藏-多租户",
        //       "version": "2",
        //       "processDefinitionId": "wd-jylxbg:2:f9a12629-450b-11f0-b32c-3606515d593d",
        //       "processDefinitionName": "网点-经营类型变更",
        //       "arr_name": "经营类型变更"
        //     },
        //     {
        //       "category": "西藏-多租户",
        //       "version": "3",
        //       "processDefinitionId": "wd-xxgz:3:f9a12624-450b-11f0-b32c-3606515d593d",
        //       "processDefinitionName": "网点-信息更正",
        //       "arr_name": "信息更正"
        //     }
        //   ],
        //   "category": "西藏-多租户"
        // }
      ],
      // 专管员列表
      // 专管员列表
      techList:[
        // {
        //   name:'',
        //   city:'',
        //   phone:'',
        // }
      ],
      computeList:[
        {
          title:'关于即开型彩票销售系统升级的通知',
          dateTime:'2025-02-20'
        },{
          title:'西藏福彩2025年春节期间工作安排',
          dateTime:'2025-02-16'
        },{
          title:'第三季度优秀网点评选活动开始报名',
          dateTime:'2025-02-13'
        }
      ],
      removeListener: null
    }
  },
  components: {
    Temp,
    InnerLoading,
    SiteInfoModal,
    // RepairModal,
    // RemoveModal,
    // RelocateModal,
    // ApplyModal
  },

  beforeDestroy() {
    if (this.removeListener) {
      this.removeListener()
    }
  },
  methods:{
    getUrl(){
      let webUrl = true;//false:是测试; true:是 正式
      let urlSite = '';
      if(webUrl){
        urlSite = 'xztrain.joyveb.com';// 线上：https://xztrain.joyveb.com/
      }else{
        urlSite = 'testxztrain.joyveb.com';// 测试：https://testxztrain.joyveb.com
      }
      if(urlSite!==''){
        window.location.href=`https://${urlSite}?web=xz&nickName=${getLocalItem('nickName')}&roles=${getLocalItem('roles')}&phone=${getLocalItem('phone')}&deptName=${getLocalItem('deptName')}`;
      }
    },
    showConfirmModal() {
      this.getApiDel();
    },
    getApiDel() {
      if(this.returnObj.processInstanceId){
        processRemove({
          processInstanceId: this.returnObj.processInstanceId
        }).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                console.log(res.data)
                this.flagTemp = false;
              } else {
                this.$toast(res.data.msg);
                return false;
              }
            }
          }
        });
      }
    },
    initWechatBackListener() {
      // 检测是否在微信环境中
      const isWechat = /micromessenger/i.test(navigator.userAgent.toLowerCase())

      if (isWechat) {
        // 添加历史记录
        window.history.pushState({ page: 'userHome' }, '', document.URL)

        // 定义处理函数
        const handleBack = (event) => {
          event.preventDefault()
          this.showConfirmModal()
        }

        // 添加事件监听
        window.addEventListener('popstate', handleBack, false)

        // 保存移除函数
        this.removeListener = () => {
          window.removeEventListener('popstate', handleBack, false)
        }
      }
    },
    // 多角色切换时
    getActiveRole(item){
      this.showRoleFlag = false;
      this.roleName = item;
      setLocalItem('local_role',item);
      if(item==='代销者'){
        // 代销者所负责的网点信息
        this.getUserSiteIdInfo();
      }
      if(item==='销售员'){
        // 销售员所负责的网点信息
        this.getUserSalesInfo();
      }
    },
    // 多网点切换时
    getActiveSite(item){
      this.showFlag = false;
      this.siteItem = item;
      this.getTechInfo();
    },
    // 网点信息和代销者信息以及销售员列表信息
    getSiteUserInfo(){
      if(this.siteItem.branchId){
        branchInfoList({
          pageNum:1,
          pageSize:10,
          branchId:this.siteItem.branchId
        }).then((res)=>{
          if(res){
            if(res.data) {
              if(res.data.code===200) {
                this.chockFlag = true;
                if(res.data.rows[0]){
                  let newObj = { ...res.data.rows[0] };
                  delete newObj.agentInfo;
                  delete newObj.salespersonInfos;
                  // 网点信息
                  this.siteItem = newObj;
                  this.getTechInfo();
                }
              }else{
                this.$toast.fail(res.data.msg);
              }
            }
          }
        });
      }else{
        this.$toast('您暂无网点编号，请您联系管理员！');
      }
    },
    //网点营业状态
    handleSiteInfoSubmit(data){
      updateBranchInfo(data).then((res)=>{
        if(res){
          if(res.data) {
            if(res.data.code===200) {
              this.getSiteUserInfo();
              this.stopBusinessFlag = false;
              this.$toast.success(res.data.msg);
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 代销者所负责的网点信息
    getUserSiteIdInfo(){
      agentInfoList({}).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              this.chockFlag = true;
              // 网点信息列表
              if(res.data.rows&&res.data.rows[0]){
                this.listSite = res.data.rows[0]?.branchInfos;
                this.siteItem = this.listSite[0];
                this.getTechInfo();
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    // 销售员所负责的网点信息
    getUserSalesInfo(){
      // salesUserInfo({
      //   userId:getLocalItem('user_id')
      // }).then((res)=>{
      //   if(res){
      //     if(res.data){
      //       console.log(res.data)
      //       // this.chockFlag = true;
      //       // // 网点信息列表
      //       // this.listSite = [res.data.rows[0].branchInfo];
      //       // this.siteItem = this.listSite[0];
      //     }
      //   }
      // })
      salespersonInfoList({}).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              this.chockFlag = true;
              // 网点信息列表
              if(res.data.rows&&res.data.rows.length>0) {
                // 代销者信息
                if (res.data.rows[0].branchInfo) {
                  this.listSite = [res.data.rows[0].branchInfo];
                  this.siteItem = this.listSite[0];
                  this.getTechInfo();
                }
              }else{
                // 销售员没有网点编号
                this.listSite = [];
                this.siteItem = {};
                Dialog.alert({
                  title: '警告',
                  message: "您暂无网点编号，请联系管理员！"
                }).then(() => {

                });
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    showModal(type){
      console.log(type)
    },
    // 流程表单提交接口
    getTempReturn(data){
      // this.innerLoading = true;
      // processGeneralsubmit(data).then((res)=>{
      //   if(res){
      //     if(res.data){
      //       if(res.data.code===200){
      //         this.$toast.success(res.data.msg);
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      this.flagTemp = false;
      //       }else{
      //         this.$toast.fail(res.data.msg);
      //       }
      //       this.innerLoading = false;
      //     }
      //   }
      // });
    },
    // 创建流程表单接口
    getDefinitionFlow(titleNameObj){
      if(titleNameObj){
        processFlowinit({
          processDefinitionName: titleNameObj.processDefinitionName,
          processDefinitionId: titleNameObj.processDefinitionId,
          categoryName:titleNameObj.category
        }).then((res)=>{
          if(res){
            if(res.data){
              if(res.data.code===200){
                this.returnObj = res.data.data;
                let formDefine = JSON.parse(res.data.data.formDefine);
                if(formDefine){
                  this.formDefine = formDefine;
                  if(formDefine.fields.length>0){
                    formDefine.fields.map((v)=>{
                      v.id_name = '';
                      if(v.id.indexOf('Name')!==-1){
                        v.id_name = 'name'
                      }else if(v.id.indexOf('name')!==-1){
                        v.id_name = 'name'
                      }else if(v.id.indexOf('phone')!==-1){
                        v.id_name = 'phone'
                      }else if(v.id.indexOf('identity')!==-1){
                        v.id_name = 'identity'
                      }
                      if(v.params.customDesign){
                        if(v.params.customDesign.type==='fileupload'){
                          v.files = [];
                        }else if(v.params.customDesign.type==='rate'){
                          v.socre = 0;
                          v.scoreValue = 0;
                          v.scoreValueFlag = true;
                        }
                      }
                    });
                    this.flowNameObj = titleNameObj;
                    this.formFields = formDefine.fields;
                    this.flagTemp = true;
                    this.siteIdObj = this.siteItem;
                  }
                }
              }else{
                this.$toast.fail(res.data.msg);
              }
              this.innerLoading = false;
            }
          }
        });
      }
    },
    getModel(type){
      if(this.chockFlag&&this.siteItem&&this.siteItem.branchId){
        this.innerLoading = true;
        this.content = 'del';
        this.historyList = [];
        this.siteIdObj = {};
        if(type==='MoveUpdate'){
          let titleNameObj = this.listPramsObj.find(item => item.arr_name === '移机');
          if(titleNameObj&&titleNameObj.processDefinitionName) {
            processIsinservice({
              siteId: this.siteItem.branchId,
              processDefinitionName: titleNameObj.processDefinitionName
            }).then((res) => {
              if (res) {
                if (res.data) {
                  if (res.data.code === 200) {
                    //为true时，不能创建，为false时可以创建
                    if (!res.data.data) {
                      this.getDefinitionFlow(titleNameObj);
                    } else {
                      this.$toast('当前网点正在流程中，不可重复操作！');
                      // this.innerLoading = false;
                      // return false;
                    }
                  } else {
                    this.$toast.fail(res.data.msg);
                  }
                  this.innerLoading = false;
                }
              }
            });
          }else{
            this.innerLoading = false;
            this.$toast('暂无移机操作！');
          }
        }else if(type==='MainService'){
          let titleNameObj = this.listPramsObj.find(item => item.arr_name === '维修');
          if(titleNameObj&&titleNameObj.processDefinitionName) {
            processIsinservice({
              siteId: this.siteItem.branchId,
              processDefinitionName: titleNameObj.processDefinitionName
            }).then((res) => {
              if (res) {
                if (res.data) {
                  if (res.data.code === 200) {
                    if (!res.data.data) {
                      this.getDefinitionFlow(titleNameObj);
                    } else {
                      this.$toast('当前网点正在流程中，不可重复操作！');
                      // this.innerLoading = false;
                      // return false;
                    }
                  } else {
                    this.$toast.fail(res.data.msg);
                  }
                  this.innerLoading = false;
                }
              }
            });
          }else{
            this.innerLoading = false;
            this.$toast('暂无维修操作！');
          }
        }
      }else{
        this.$toast('您当前暂无网点编号，请联系管理员！');
      }
    },
    // 常用功能
    showPage(type){
      if(type==='info'){
        // 网点信息
        if(this.chockFlag&&this.siteItem&&this.siteItem.branchId){
          this.$router.push({path: '/stationInfo',query:{'sid':this.siteItem.branchId}});
        }else{
          this.$toast('您暂无网点编号，请您联系管理员！');
        }
      }else if(type==='majorPerson'){
        if(this.siteItem&&this.siteItem.branchId) {
          // 停业申请
          this.stopBusinessFlag = !this.stopBusinessFlag;
        }else{
          this.$toast('您暂无网点编号，请您联系管理员！');
        }
      }else if(type==='myApply'){
        if(this.siteItem&&this.siteItem.branchId) {
          this.$router.push({path: type});
        }else{
          this.$toast('您暂无网点编号，请您联系管理员！');
        }
      }else if(type==='active'){
        if(this.siteItem&&this.siteItem.branchId){
          this.$router.push({path:type,query:{'sid':this.siteItem.branchId}});
        }else{
          this.$toast('您暂无网点编号，请您联系管理员！');
        }
        // openWinner
      }else if(type==='openWinner'){
        if(this.siteItem&&this.siteItem.branchId) {
          this.$router.push({path:type});
        }else{
          this.$toast('您暂无网点编号，请您联系管理员！');
        }
      }else if(type==='consumables'){
        if(this.siteItem&&this.siteItem.branchId) {
          // console.log('耗材申领')
          // this.$toast('开发中，敬请期待！');
          this.$router.push({path: '/consumables',query:{'sid':this.siteItem.branchId}});
        }else{
          this.$toast('您暂无网点编号，请您联系管理员！');
        }
      }else if(type==='medium'){
        // 语音小助手
        if(this.siteItem&&this.siteItem.branchId) {
          this.$router.push({path:type,query:{'sid':this.siteItem.branchId}});//'54010888'
        }else{
          this.$toast('您暂无网点编号，请您联系管理员！');
        }
      }else if(type==='hdmiMedium'){
        // hdmi大屏
        if(this.siteItem&&this.siteItem.branchId) {
          this.$router.push({path:type,query:{'sid':this.siteItem.branchId}});//'54010888'
        }else{
          this.$toast('您暂无网点编号，请您联系管理员！');
        }
      }else{
        this.$toast('开发中，敬请期待！');
        // this.$router.push({path:type});
      }
    },
    showApplicationDetail(item,type){
      this.innerLoading = true;
      this.content = 'close';
      this.formFields = [];
      this.returnObj = {};
      this.formDefine = {};
      processTaskHistorical({
        processInstanceId:item.processInstanceId,
        handler:false
      }).then((res)=> {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if(res.data.data.historicActivityInstances&&res.data.data.historicActivityInstances.length>0){
                res.data.data.historicActivityInstances.map((v)=>{
                  if(v.formInfo.fields){
                    v.formInfo.fields.map((i)=>{
                      if(i.params.customDesign.type==='fileupload'){
                        i.files =  i.value?i.value.split(','):[];
                      }else if(i.params.customDesign.type==='rate'){
                        i.value = i.value?parseInt(i.value)/2:0;
                      }
                    })
                  }
                });
                this.historyList = res.data.data.historicActivityInstances;
                if(type==='info'){
                  this.flagTemp = true;
                }
              }else{
                this.historyList = [];
                this.showPage('myApply');
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
            if(type==='info'){
              this.innerLoading = false;
            }
          }
        }
      });
    },
    // 退出
    outLogin(){
      logoutRequest().then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              if(getLocalItem('open_id')){
                delLocalItem('local_role');
                this.$router.push({path: '/login',query:{openid: getLocalItem('open_id')}});
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 我的网点申请列表
    getSiteApplyList(){
      processAllmytask({
        size:2,//每页数量
        page:0,//当前页码
        classify:0,//（0:全部,1:进行中,2：已完结）
      }).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              if(res.data.data.list&&res.data.data.list.length>0){
                res.data.data.list.map((v)=>{
                  if(v.processInstanceName){
                    if(v.processInstanceName.split('-')&&v.processInstanceName.split('-').length>1){
                      v.arr_name = v.processInstanceName.split('-')[1]
                    }else{
                      v.arr_name = v.processInstanceName;
                    }
                  }
                });
                this.dataApplyList = res.data.data.list;
              }else{
                this.dataApplyList = [];
              }
            }else{
              this.dataApplyList = [];
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 网点的流程类型
    getFlowList(){
      processFlowlist({}).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              res.data.data.msgs.map((v)=>{
                if(v.processDefinitionName){
                  if(v.processDefinitionName.split('-')&&v.processDefinitionName.split('-').length>1){
                    v.arr_name = v.processDefinitionName.split('-')[1]
                  }else{
                    v.arr_name = v.processDefinitionName
                  }
                }
              });
              this.listPramsObj = res.data.data.msgs;
            }else{
              this.$toast.fail(res.data.msg);
            }
          }
        }
      });
    },
    // 获取区域的专管员
    getTechInfo(){
      if(this.siteItem.branchId){
        xzsStaffInfoParty({
          siteid:this.siteItem.branchId
        }).then((res)=>{
          if(res){
            if(res.data){
              if(res.data.code===200){
                if(res.data.data){
                  this.techList = res.data.data;
                }else{

                }
              }else{
                this.$toast.fail(res.data.msg);
              }
            }
          }
        });
      }
    },
  },
  mounted() {
    this.initWechatBackListener()
    // 网点的流程类型
    this.getFlowList();
    // 我的网点申请列表
    this.getSiteApplyList();
  },
  created(){
    let arr = getLocalItem('roles');
    if(arr){
      let att = arr.split(',');
      //一人多角色
      if(att.length>1){
        this.roleList = att;
        if(getLocalItem('local_role')){
          this.roleName = getLocalItem(('local_role'));
        }else{
          this.roleName = this.roleList[0];
          setLocalItem('local_role',this.roleList[0]);
        }
        if(this.roleName === '代销者'){
          // 代销者所负责的网点信息
          this.getUserSiteIdInfo();
        }
        if(this.roleName === '销售员'){
          // 销售员所负责的网点信息
          this.getUserSalesInfo();
        }
      }else{
        this.roleName = arr;
        setLocalItem('local_role',arr);
        let url_openid = this.$route.query.openid;
        if(arr.indexOf('专管员')!==-1){
          this.$router.push({path:'/techHome',query:{openid:url_openid}});
        }else if(arr.indexOf('维修')!==-1){
          this.$router.push({path:'/techHome',query:{openid:url_openid}});
        }
        if(this.roleName === '代销者'){
          // 代销者所负责的网点信息
          this.getUserSiteIdInfo();
        }
        if(this.roleName === '销售员'){
          // 销售员所负责的网点信息
          this.getUserSalesInfo();
        }
      }
    }else{
      let url_openid = this.$route.query.openid;
      if(getLocalItem('open_id')){
        this.$router.push({path:'/login',query:{openid:getLocalItem('open_id')}})
      }
      if(url_openid){
        this.$router.push({path:'/login',query:{openid:url_openid}})
      }
    }
  }
}
</script>
<template>
  <!-- 首页 -->
  <!--  网点可以申请【维修、移机、经营类型变更、地址信息变更 】-->
  <!--  专管员可以申请【巡检、撤机、经营类型变更、地址信息变更、代销者变更 】-->
  <div class="home-wrap-taine">
    <!--  加载中...  -->
    <inner-loading v-model="innerLoading"></inner-loading>
    <!--  动态表单模版    -->
    <Temp v-model="flagTemp" :content="content" :variablesObj="{}" :flowNameObj="flowNameObj" :historyList="historyList" :siteIdObj.sync="siteIdObj" :returnObj="returnObj" :formDefine="formDefine" :formFields="formFields" @submit="getTempReturn"></Temp>
    <!--  停业申请 -->
    <site-info-modal v-model="stopBusinessFlag" :siteItem="siteItem" @submit="handleSiteInfoSubmit" />
    <!--  html -->
    <div class="header">
      <div class="in-box">
        <div class="station-in-box">
          <div class="station-selector-wrapper bck-left" :class="roleList.length>1?'bck-wid':''">
            <div class="current-station" :class="roleList.length>1?'bck-role':''" @click="showRoleFlag=!showRoleFlag">
              <div class="current-station-name">{{roleName}}</div>
              <div class="current-station-icon" v-show="roleList.length>1"><van-icon name="arrow-down" color="white" /></div>
            </div>
            <div class="station-selector" v-show="showRoleFlag&&roleList.length>1">
              <div class="station-item" @click="getActiveRole(item)" v-for="(item,index) in roleList" :key="index">
                <div class="station-info">
                  <div class="station-name">{{item}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="station-selector-wrapper bck-left">
            <div class="current-station" :class="listSite.length>0?'bck':''" @click="showFlag=!showFlag">
              <div class="current-station-name">{{ siteItem.branchId }}（{{siteItem.businessType?(siteItem.businessType==='1'?'专营店':'兼营店'):''}}）</div>
              <div class="current-station-icon" v-show="listSite.length>1"><van-icon name="arrow-down" color="white" /></div>
            </div>
            <div class="station-selector" style="width:190px;" v-show="showFlag&&listSite.length>1">
              <div class="station-item" @click="getActiveSite(item)" v-for="(item,index) in listSite" :key="index">
                <div class="station-icon">🏪</div>
                <div class="station-info">
                  <div class="station-name">{{ item.branchId }}（{{item.businessType==='1'?'专营店':'兼营店'}}）</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="station-selector-wrapper bck-left" style="display: flex;height:30px;align-items: center;justify-content: flex-end" @click="outLogin">退出</div>
      </div>
    </div>
    <div class="content">
      <!-- 统计数据 -->
      <div class="stats-container">
        <!--        <div class="stat-card-home">-->
        <!--          <div class="stat-title-card"><span>📱</span></div>-->
        <!--          <div class="stat-title-card f-ba">扫一扫</div>-->
        <!--          <div class="stat-title-card f-sm">-->
        <!--            扫码核验体验券-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="stat-card-home">
          <div class="stat-title">网点信息：{{siteItem.branchId}}</div>
          <div class="stat-title">经营类型：{{siteItem.businessType?(siteItem.businessType==='1'?'专营店':'兼营店'):''}}</div>
          <div class="stat-title">
            营业状态：<span class="green" v-if="siteItem.businessStatus&&siteItem.businessStatus===1">正常营业</span><span class="reds" v-else-if="siteItem.businessStatus&&siteItem.businessStatus===2">暂停营业</span>
          </div>
        </div>
        <div class="stat-card-home" v-show="siteItem&&siteItem.branchId&&techList.length>0" v-for="(item,index) in techList" :key="index">
          <div class="stat-title">专管员：{{ item.name }}</div>
          <div class="stat-title">区域：{{ item.city }}</div>
          <div class="stat-title">电话：<a :href="'tel:'+item.phone" v-if="item.phone">📞{{ item.phone }}</a></div>
        </div>
      </div>
      <!-- 常用功能 -->
      <div class="section-title">常用功能</div>
      <!-- 快捷操作 -->
      <div class="quick-actions">
        <div class="action-btn" @click="showPage('consumables')">
          <div class="action-icon">🗃️</div>
          <div class="action-text">热敏纸申领</div>
        </div>
        <div class="action-btn" @click="showPage('openWinner')">
          <div class="action-icon">🎯</div>
          <div class="action-text">开奖信息</div>
        </div>
        <div class="action-btn" @click="getModel('MainService')">
          <div class="action-icon">🔧</div>
          <div class="action-text">设备报修</div>
        </div>
        <!--        先注释，以后有活动在放开-->
        <!--        <div class="action-btn" @click="showPage('active')">-->
        <!--          <div class="action-icon">📝</div>-->
        <!--          <div class="action-text">调查问卷</div>-->
        <!--        </div>-->
        <!--          <div class="action-btn" @click="showPage('marketing')">-->
        <!--            <div class="action-icon">🎁</div>-->
        <!--            <div class="action-text">营销活动</div>-->
        <!--          </div>-->
        <div class="action-btn" @click="showPage('info')">
          <div class="action-icon">📋</div>
          <div class="action-text">网点信息</div>
        </div>
      </div>
      <div class="quick-actions" style="grid-template-columns: repeat(4, 1fr);">
        <!--          <div class="action-btn" @click="" v-show="roleName==='代销者'">-->
        <!--            <div class="action-icon">📤</div>-->
        <!--            <div class="action-text">撤机申请</div>-->
        <!--          </div>-->
        <div class="action-btn" @click="getModel('MoveUpdate')" v-show="roleName==='代销者'">
          <div class="action-icon">🚚</div>
          <div class="action-text">移机申请</div>
        </div>
        <div class="action-btn" @click="showPage('majorPerson')" v-show="roleName==='代销者'">
          <div class="action-icon">👤</div>
          <div class="action-text">停业申请</div>
        </div>
        <div class="action-btn" v-if="siteItem&&siteItem.branchId&&siteItem.assistant===1" @click="showPage('medium')">
          <div class="action-icon">🖼</div>
          <div class="action-text">助手管理</div>
        </div>
        <div class="action-btn" v-if="siteItem&&siteItem.branchId&&siteItem.assistant===1" @click="showPage('hdmiMedium')">
          <div class="action-icon">🖥</div>
          <div class="action-text">HDMI管理</div>
        </div>
        <div class="action-btn" @click="getUrl">
          <div class="action-icon">🗂</div>
          <div class="action-text">培训平台</div>
        </div>
        <div class="action-btn no-finish" @click="showPage('logistics')">
          <div class="action-icon">📦</div>
          <div class="action-text">物流查询</div>
        </div>
        <!---->
      </div>
      <!-- 我的申请 -->
      <div class="section-title">我的申请 <span class="view-all" @click="showPage('myApply')">查看全部 ></span></div>
      <div class="card" v-for="(item,index) in dataApplyList" :key="index" v-show="dataApplyList.length>0">
        <div class="card-title">
          {{item.arr_name}}
          <span class="status-tag tag-progress" v-if="item.type==='1'">处理中</span>
          <span class="status-tag tag-noStars" v-else-if="item.type==='3'">待领取</span>
          <span class="status-tag tag-complete" v-else>已完成</span>
        </div>
        <div class="card-info" v-if="item.variables&&item.variables.siteid">
          <div class="info-label">申请网点</div>
          <div class="info-value">{{ item.variables.siteid }}</div>
        </div>
        <div class="card-info">
          <div class="info-label">申请时间</div>
          <div class="info-value">{{item.created }}</div>
        </div>
        <div class="card-info" v-show="item.name">
          <div class="info-label">流程进度</div>
          <div class="info-value">{{ item.name }}</div>
        </div>
        <div class="divider"></div>
        <div class="card-actions">
          <button class="btn btn-outline" @click="showApplicationDetail(item,'info')">任务详情</button>
          <!--            <button class="btn btn-primary" @click="showModal('followUpModal')" v-if="item.type==='1'">催办</button>-->
        </div>
      </div>
      <div class="card" style="text-align: center" v-show="dataApplyList.length===0">
        暂无申请数据~
      </div>
      <!-- 系统公告 -->
      <!--      <div class="section-title">系统公告</div>-->
      <!--      <div class="card">-->
      <!--        <div class="timeline">-->
      <!--          <div class="timeline-item" v-for="(item,index) in computeList" :key="index">-->
      <!--            <div class="timeline-time">{{item.dateTime}}</div>-->
      <!--            <div class="timeline-content">{{item.title}}</div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>
<style scoped lang="scss">
.home-wrap-taine{
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
}
</style>